import type { WhereField, WhereKind } from './types.js';

export const WHERE_OPERATORS = [
  'in',
  'notIn',
  '=',
  '!=',
  'null',
  'notNull',
  'contains',
  'doesNotContain',
  '>',
  '<',
  'between',
  'withinLast',
  'notWithinLast',
] as const;
export type WhereOperator = (typeof WHERE_OPERATORS)[number];

export const OPERATOR_LABEL: Record<WhereOperator, string> = {
  in: 'is',
  notIn: 'is not',
  '=': 'is',
  '!=': 'is not',
  null: 'is empty',
  notNull: 'is not empty',
  contains: 'contains',
  doesNotContain: "doesn't contain",
  '>': 'greater than',
  '<': 'less than',
  between: 'between',
  withinLast: 'less than',
  notWithinLast: 'more than',
};

/** The first operator is the default when a field is picked. */
export const OPERATORS_BY_KIND: Record<WhereKind, readonly WhereOperator[]> = {
  text: ['contains', 'doesNotContain', 'in', 'notIn', 'null', 'notNull'],
  choice: ['in', 'notIn', 'null', 'notNull'],
  number: ['between', '=', '!=', '>', '<', 'null', 'notNull'],
  date: ['withinLast', 'notWithinLast', 'between', 'null', 'notNull'],
  yes_no: ['='],
  score: ['between', '>', '<', 'null', 'notNull'],
};

const VIEW_OPERATORS: readonly WhereOperator[] = ['in', 'notIn'];

/** The operators one field takes: its kind's list, except "In a saved View" (is, is not). */
export function operatorsFor(field: Pick<WhereField, 'key' | 'kind'>): readonly WhereOperator[] {
  return field.key === 'view' ? VIEW_OPERATORS : OPERATORS_BY_KIND[field.kind];
}

export const DATE_UNITS = ['days', 'months'] as const;
export type DateUnit = (typeof DATE_UNITS)[number];
